import { render, staticRenderFns } from "./TenderTerms.vue?vue&type=template&id=11ddfce0"
import script from "./TenderTerms.vue?vue&type=script&lang=js"
export * from "./TenderTerms.vue?vue&type=script&lang=js"
import style0 from "./TenderTerms.vue?vue&type=style&index=0&id=11ddfce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports